<template>
  <div class="border-b bg-gray-50 px-4 py-3 md:px-6">
    <div class="space-y-2 md:hidden">
      <div
        class="flex items-center justify-between text-xs font-semibold text-[#2e234b]"
      >
        <span>{{ stepLabels[activeStep] }}</span>
        <span>{{ currentStepIndex + 1 }} / {{ stepOrder.length }}</span>
      </div>
      <div class="h-1.5 w-full overflow-hidden rounded-full bg-[#2e234b]/15">
        <div
          class="h-full rounded-full bg-pink-500 transition-all duration-300"
          :style="{ width: `${progressPct}%` }"
        ></div>
      </div>
    </div>

    <div
      class="hidden flex-wrap gap-4 text-xs font-semibold text-[#2e234b] md:flex"
    >
      <span
        v-for="(step, idx) in stepOrder"
        :key="step"
        class="flex items-center gap-2"
      >
        <span
          :class="[
            'flex h-6 w-6 items-center justify-center rounded-full text-[11px] text-white',
            step === activeStep ? 'bg-pink-500' : 'bg-[#2e234b]/60',
          ]"
        >
          {{ idx + 1 }}
        </span>
        <span
          :class="step === activeStep ? 'text-pink-500' : 'text-[#2e234b]'"
          >{{ stepLabels[step] }}</span
        >
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { TicketFlowStep } from "./types";

const props = defineProps<{
  activeStep: TicketFlowStep;
  stepOrder: TicketFlowStep[];
  stepLabels: Record<TicketFlowStep, string>;
}>();

const currentStepIndex = computed(() => {
  const idx = props.stepOrder.indexOf(props.activeStep);
  return idx >= 0 ? idx : 0;
});

const progressPct = computed(() => {
  if (props.stepOrder.length <= 1) return 100;
  return (currentStepIndex.value / (props.stepOrder.length - 1)) * 100;
});
</script>
